import request from "@/utils/request";


// 用户捐款
export function abcPay(type, sourceId, money) {
    return request({
        url: '/h5/pay/bankPay?type=' + type + '&sourceId=' + sourceId + '&money=' + money,
        method: 'post',
    })
}


// 用户银行认证费用
export function bankAuthPay() {
    return request({
        url: '/h5/pay/bankAuthPay',
        method: 'post',
    })
}
